/** @type {import('@nuxt/types').Plugin} */
export default ({ store }, inject) => {
    /**
     * Gets the price for given subscription type and plan.
     *
     * @param {UserWebApi.SubscriptionPlan} plan
     * @param {UserWebApi.SubscriptionType} type
     * @return {string}
     */
    function getPrice(plan, type) {
        let price = '';

        /** @type {TIDAL.SubscriptionPrices} */
        const userPrices = store.state.userPrices;
        const priceMapping = userPrices[type];

        if (priceMapping && plan in priceMapping) {
            price = priceMapping[plan] || '';
        }

        return price;
    }

    inject('userPrices', {
        get: getPrice,
    });
};
